export const MAP_BOUNDARY_OFFSET = 2.5;
export const DEFAULT_LONG = -73.97;
export const DEFAULT_LAT = 40.76;
